/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetKiosksOrders = (data: any) =>
  useQuery({
    queryKey: [
      "GetKiosksOrders",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.sourceSPId,
      data?.isPrepack,
      data?.isBranchToATM,
    ],
    queryFn: ({ signal }) =>
      client(`kiosk/services/open/requests`, { data, signal }),
  });

export const useCancelKioskOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/cancel/requests`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetKiosksOrders"] });
    },
  });
};

export const useAssignKioskRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`kiosk/services/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetKiosksOrders"],
      });
    },
  });
};

export const useCreateKioskOrder = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/create/request`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useCreateMultiKioskOrder = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/create/multiple/requests`, {
        data,
        successMessage: "Multiple requests submitted successfully!",
      }),
  });

export const useCreateKioskBulkOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/create/bulk/requests`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetKiosksOrders"] });
    },
  });
};

export const useCreateKioskOpenOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/create/bulk/requests/open/model`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["CreateKioskOpenOrders"],
      });
    },
  });
};

export const useGetKioskDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetKioskDetails", data?.requestId],
    queryFn: () => client(`kiosk/services/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditKioskJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetKioskDetails"] });
    },
  });
};

export const useUpdateKioskStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetKioskDetails"] });
    },
  });
};

export const useGetAEDTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/download/atm/aed/template`, {
        data,
      }),
  });

export const useGetSmallDenominationsTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/download/denominations/template`, { data }),
  });

export const useAssignBagSeals = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/bulk/bags/assignment`, {
        data,
        successMessage: "Bag Seal Assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetKiosksOrders"] });
    },
  });
};

export const useAssignKioskBags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/assign/consignments`, { data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetKioskDetails"] });
    },
  });
};

export const useUpdateKioskAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetKioskDetails"] });
    },
  });
};

export const useValidateBulkBagsAssignment = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`kiosk/services/validate/bulk/bags/assignment`, {
        data,
        errorMessage: "Invalid barcodes found.",
      }),
  });
